/**
 * Created by cl-macmini-51 on 01/05/18.
 */
import { Injectable } from '@angular/core';
import { CacheConfig, CacheConfigKey, CacheConfigType } from '../../classes/cache_config';

import { ApiService } from '../../services/api.service';
import {ApiRepository} from '../../services/api-repository';
// import { Headers } from '@angular/http';

@Injectable()
export class CookieSettingService {
  constructor(private api: ApiService,private apirepository:ApiRepository) {
  }

  enableCookie(data) {
    // const headers = new Headers();
    const obj = {
      'url': 'customer_accept_cookie_policy',
      'body': data,
      // 'headers': headers
    };
    return this.api.post(obj);
  }

  getPoliciesData(data) {
    // const headers = new Headers();
    const obj = {
      'url': 'termAndCondition/getTermAndConditionOpen',
      'body': data,
      // 'headers': headers
    };
    // if (this.sessionService.isPlatformServer())
      obj.body['source'] = '0';
      const config = new CacheConfig(CacheConfigType.MEMORY, CacheConfigKey.PRIVACY_POLICY_DATA);
      return this.apirepository.get(obj,config);
  }

}
